import React, { useEffect, useRef, useState } from "react";
import {
    Box,
    Button,
    Card,
    CardContent,
    CardMedia,
    Grid,
    Paper,
    Skeleton,
    Tab,
    Tabs,
    tabsClasses,
    Typography,
} from "@mui/material";
import { styles } from "../../style";
import { MoneyBillIcon } from "../../icons/MoneyBillIcon";
import { newSpeakersSkeleton, speakersSkeleton, treadingSkeleton } from "./skeleton";
import ScrollContainer from "../../components/ScrollContainer";
import { OutlinedUserIcon } from "../../icons/OutlinedUserIcon";
import { BoltIcon } from "../../icons/BoltIcon";
import { JetFighterUpIcon } from "../../icons/JetFighterUpIcon";
import { OutlinedUsersIcon } from "../../icons/OutlinedUsersIcon";
import { OutlinedEyeIcon } from "../../icons/OutlinedEyeIcon";
import SettingsOutlinedIcon from "@mui/icons-material/SettingsOutlined";
import { get } from "../../api";
import { useAuth } from "../../hooks/useAuth";
import { Modal } from "../../components/Modal";
import { Speaker } from "../Speaker";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { initialize, selectDashboardData } from "./dashboardSlice";
import imageFemalePlaceholder from "../../assets/images/placeholders/image_placeholder_female.png";
import imageMalePlaceholder from "../../assets/images/placeholders/image_placeholder_male.png";

const tabsListData = [
    {
        tab: "Top 10 Booked Speakers in Finance",
        data: [
            {
                img: "avatar_11.png",
                name: "Adam Grant",
                para: "Organizational Psychologist, The Wharton School of Business; Bestselling Author; Host: WorkLife, a TED Original Podcast",
            },
            {
                img: "avatar_10.png",
                name: "Daniel Pink",
                para: "#1 New York Times Bestselling Author of The Power of Regret, When, To Sell is Human, Drive, and A Whole New Mind",
            },
            {
                img: "avatar_5.png",
                name: "Liz Murray",
                para: "Inspirational Speaker and Bestselling Author",
            },
            {
                img: "avatar_1.png",
                name: "Jon Favreau",
                para: "Founder, Crooked Media, Host of Pod Save America; Assistant to the President and Director of Speechwriting for President Barack Obama (2009-2013)",
            },
        ],
    },
    {
        tab: "Top 10 Proposed Speakers in Finance",
        data: [
            {
                img: "avatar_11.png",
                name: "Jon Favreau",
                para: "Founder, Crooked Media, Host of Pod Save America; Assistant to the President and Director of Speechwriting for President Barack Obama (2009-2013)",
            },
            {
                img: "avatar_10.png",
                name: "Liz Murray",
                para: "Inspirational Speaker and Bestselling Author",
            },
            {
                img: "avatar_5.png",
                name: "Daniel Pink",
                para: "#1 New York Times Bestselling Author of The Power of Regret, When, To Sell is Human, Drive, and A Whole New Mind",
            },
            {
                img: "avatar_10.png",
                name: "Liz Murray",
                para: "Inspirational Speaker and Bestselling Author",
            },
            {
                img: "avatar_5.png",
                name: "Daniel Pink",
                para: "#1 New York Times Bestselling Author of The Power of Regret, When, To Sell is Human, Drive, and A Whole New Mind",
            },
        ],
    },
    {
        tab: "Trending Topics",
        data: [
            {
                id: "1",
                icon: MoneyBillIcon,
                title: "Finance and Cryptocurrencies",
            },
            {
                id: "2",
                icon: OutlinedUserIcon,
                title: "Healthcare and Wellness",
            },
            {
                id: "3",
                icon: BoltIcon,
                title: "Innovation",
            },
            {
                id: "4",
                icon: JetFighterUpIcon,
                title: "War in the Middle East",
            },
            {
                id: "5",
                icon: ({ ...props }) => (
                    <SettingsOutlinedIcon
                        sx={{
                            fontSize: "1rem",
                        }}
                        {...props}
                    />
                ),
                title: "Climate Change",
            },
            {
                id: "6",
                icon: OutlinedUsersIcon,
                title: "Women in Business",
            },
            {
                id: "7",
                icon: OutlinedEyeIcon,
                title: "Visions for Change",
            },
            {
                id: "8",
                icon: MoneyBillIcon,
                title: "Finance and Cryptocurrencies",
            },
            {
                id: "9",
                icon: ({ ...props }) => (
                    <SettingsOutlinedIcon
                        sx={{
                            fontSize: "1rem",
                        }}
                        {...props}
                    />
                ),
                title: "Climate Change",
            },
        ],
    },
];
function TopicsFeed() {
    const dashboardData = useSelector(selectDashboardData);

    const [data, setData] = useState(dashboardData?.topicsFeed || []);
    const [value, setValue] = React.useState(
        dashboardData?.topicsFeed?.length > 0 ? dashboardData?.topicsFeed[0].id : undefined
    );
    const [loading, setLoading] = useState(false);
    const [selectTopicsList, setSelectTopicsList] = useState([]);
    const { getUserDetailsNotAsync } = useAuth();
    const userDetails = getUserDetailsNotAsync();
    const [openSpeakerScreen, setOpenSpeakerScreen] = useState(false);
    const navigate = useNavigate();
    const [speakerSearchSelectedTeb, setSpeakerSearchSelectedTeb] = useState("Biographies");
    const [selectedSpeaker, setSelectedSpeaker] = useState({
        Id: "",
        name: "",
        img: "",
    });
    const [selectTopicsListBoxHeight, setSelectTopicsListBoxHeight] = useState(0);
    const dispatch = useDispatch();
    const selectTopicsListBoxRef = useRef();

    useEffect(() => {
        if (dashboardData.topicsFeed) {
            setData(dashboardData.topicsFeed);
            if (dashboardData.topicsFeed.length > 0) {
                setValue(dashboardData.topicsFeed[0].id);
            }
            // setLoading(false);
        } else {
            setLoading(true);
            get("dashboard/getTrendingDashboardItems", { accountId: userDetails.contact.accountId })
                .then((res) => {
                    if (res.isSuccess && res.data?.length > 0) {
                        setData(res.data);
                        if (res.data.length > 0) {
                            setValue(res.data[0].id);
                        }
                    }
                    setLoading(false);

                    dispatch(
                        initialize({
                            topicsFeed: res.data,
                        })
                    );
                })
                .catch((error) => {
                    console.error("Error fetching dashboard data:", error);
                    setLoading(false);
                });
        }
    }, []);

    useEffect(() => {
        if (!selectTopicsListBoxRef?.current) {
            return;
        }

        const handleResize = () => {
            console.log("resize...", selectTopicsListBoxRef?.current?.clientHeight);
            setSelectTopicsListBoxHeight(selectTopicsListBoxRef?.current?.clientHeight);
        };

        if (selectTopicsList?.length === 1) {
            handleResize();
        }

        if (selectTopicsList?.length >= 1) {
            window.addEventListener("resize", handleResize);
        }

        // Listen for resize event

        // Cleanup on unmount
        return () => {
            window.removeEventListener("resize", handleResize);
        };
    }, [selectTopicsList?.length]);

    const handleChange = (event, newValue) => {
        setValue(newValue);
    };

    const handleTopicSelection = (topicId, tabData) => {
        const topic = tabData.data.find((c) => c.id === topicId);
        const isTopicAlreadySelected = selectTopicsList.find((c) => c.id === topicId);

        if (isTopicAlreadySelected) {
            setSelectTopicsList((prevList) => {
                return prevList.filter((cItem) => cItem.id !== topicId);
            });
        } else {
            setSelectTopicsList((prevList) => [...prevList, topic]);
        }
    };

    const navigateToSearch = () => {
        navigate("/speaker-search", {
            state: {
                selectedTopics: selectTopicsList,
            },
        });
    };

    return (
        <Paper
            sx={{
                borderRadius: "10px",
                padding: "1rem",
                boxShadow: "0px 1px 3px 0px rgba(16, 24, 40, 0.10), 0px 1px 2px 0px rgba(16, 24, 40, 0.06)",
                height: "100%",
                position: "relative",
            }}>
            <Typography
                component={"h1"}
                sx={{
                    ...styles.paperHeader,
                }}>
                WSB Speakers and Topics Feed
            </Typography>

            <Box
                sx={{
                    marginTop: "8px",
                    // marginLeft: "-14px"
                }}>
                <Tabs
                    value={value}
                    onChange={handleChange}
                    aria-label="Topics Tabs"
                    variant="scrollable"
                    // scrollButtons
                    allowScrollButtonsMobile
                    textColor="primary"
                    indicatorColor="primary"
                    sx={{
                        [`& .${tabsClasses.scrollButtons}`]: {
                            "&.Mui-disabled": { opacity: 0.3 },
                        },

                        minHeight: "unset",
                        // maxHeight: "44px",
                        "& .MuiButtonBase-root.MuiTab-root": {
                            color: "#A0A0AB",
                            fontSize: "12px",
                            fontWeight: 600,
                            textTransform: "initial",
                            minHeight: "unset",
                            padding: "10px 0px",
                            margin: "0 8px",

                            "&.Mui-selected": {
                                color: "#444CE7",
                            },
                        },

                        "& .MuiTabs-indicator": {
                            backgroundColor: "#444CE7",
                        },
                    }}>
                    {data?.map((cTab, index) => {
                        return <Tab key={index} label={cTab.title} value={cTab.id} />;
                    })}
                </Tabs>
            </Box>

            <Box marginTop={"1rem"} minHeight={"315px"} maxHeight={"315px"} height={"315px"}>
                {loading && <>{speakersSkeleton}</>}

                {!loading && (
                    <Box>
                        <>
                            {data?.length === 0 && (
                                <Box
                                    sx={{
                                        display: "flex",
                                        justifyContent: "center",
                                        alignItems: "center",
                                        height: "310px",
                                    }}>
                                    No list found
                                </Box>
                            )}
                        </>
                        <>
                            {data?.length > 0 && (
                                <>
                                    {data.map((cTab) => (
                                        <Box key={cTab.id}>
                                            {cTab.recordType === "Speaker List" && value === cTab.id && (
                                                <ScrollContainer>
                                                    {cTab.data?.map((cItem, index) => (
                                                        <Card
                                                            key={index}
                                                            onClick={() => {
                                                                setOpenSpeakerScreen(true);
                                                                setSpeakerSearchSelectedTeb("Biographies");
                                                                setSelectedSpeaker({
                                                                    Id: cItem.speakerId,
                                                                    name: cItem.name,
                                                                    img: cItem.img,
                                                                    gender: cItem.gender,
                                                                });
                                                            }}
                                                            sx={{
                                                                minWidth: 220,
                                                                maxWidth: 220,
                                                                borderRadius: "10px",
                                                                border: "1px solid #E4E4E7",
                                                                background: "#FFF",
                                                                marginRight: "1rem",
                                                            }}>
                                                            {cItem.img && (
                                                                <CardMedia
                                                                    component="img"
                                                                    height="185"
                                                                    image={cItem.img}
                                                                    alt={cItem.name}
                                                                    sx={{
                                                                        objectFit: "cover",
                                                                        objectPosition: "top",
                                                                        borderRadius: "8px 8px 0 0",
                                                                    }}
                                                                />
                                                            )}
                                                            {!cItem.img && (
                                                                <Skeleton
                                                                    variant="rounded"
                                                                    sx={{
                                                                        borderRadius: "8px 8px 0 0",
                                                                    }}
                                                                    width={"220px"}
                                                                    height={"185px"}></Skeleton>
                                                            )}
                                                            <CardContent>
                                                                <Typography
                                                                    gutterBottom
                                                                    variant="h5"
                                                                    component="div"
                                                                    fontSize={"16px"}
                                                                    fontWeight={600}
                                                                    color={"#1A2847"}
                                                                    sx={{
                                                                        textOverflow: "ellipsis",
                                                                        overflow: "hidden",
                                                                        whiteSpace: "nowrap",
                                                                    }}>
                                                                    {cItem.name}
                                                                </Typography>
                                                                <Typography
                                                                    variant="body2"
                                                                    fontSize={"12px"}
                                                                    fontWeight={400}
                                                                    color={"#3F3F46"}
                                                                    title={cItem.description}
                                                                    sx={{
                                                                        overflow: "hidden",
                                                                        display: "-webkit-box",
                                                                        WebkitLineClamp: "4",
                                                                        WebkitBoxOrient: "vertical",
                                                                    }}>
                                                                    {cItem.description}
                                                                </Typography>
                                                            </CardContent>
                                                        </Card>
                                                    ))}
                                                </ScrollContainer>
                                            )}
                                            {cTab.recordType === "Topic List" && value === cTab.id && (
                                                <Box height={"330px"}>
                                                    <Grid
                                                        component={"ul"}
                                                        container
                                                        spacing={2}
                                                        sx={{
                                                            maxHeight: {
                                                                xs:
                                                                    selectTopicsList?.length > 0
                                                                        ? `${
                                                                              330 -
                                                                              ((selectTopicsListBoxHeight || 0) + 10)
                                                                          }px`
                                                                        : "320px",
                                                                md:
                                                                    selectTopicsList?.length > 0
                                                                        ? `${
                                                                              330 -
                                                                              ((selectTopicsListBoxHeight || 0) + 0)
                                                                          }px`
                                                                        : "330px",
                                                            },
                                                            overflow: "auto",
                                                        }}>
                                                        {cTab.data?.map((cItem) => (
                                                            <Grid key={cItem.id} component={"li"} item sx={{ listStyle: "none" }}>
                                                                <Typography
                                                                    component={Button}
                                                                    sx={{
                                                                        borderRadius: "10px",
                                                                        border: `1px solid ${
                                                                            selectTopicsList.find(
                                                                                (c) => c.id === cItem.id
                                                                            )
                                                                                ? "#444CE7"
                                                                                : "#E4E4E7"
                                                                        }`,
                                                                        background: "#FFF",
                                                                        padding: "7px 18px 6px 16px",

                                                                        display: "flex",
                                                                        alignItems: "center",

                                                                        color: "#3F3F46",
                                                                        fontSize: "16px",
                                                                        fontWeight: 600,
                                                                        lineHeight: "24px",
                                                                    }}
                                                                    onClick={() => {
                                                                        handleTopicSelection(cItem.id, cTab);
                                                                    }}>
                                                                    {cItem.name}
                                                                </Typography>
                                                            </Grid>
                                                        ))}
                                                    </Grid>

                                                    {selectTopicsList?.length > 0 && (
                                                        <Box
                                                            ref={selectTopicsListBoxRef}
                                                            sx={{
                                                                background: "#F5F8FF",
                                                                marginTop: "1.5rem",
                                                                padding: "1rem",
                                                                margin: "1.5rem -1rem 0",

                                                                position: "absolute",
                                                                bottom: "0",
                                                                left: "1rem",
                                                                right: "1rem",
                                                                borderRadius: "0 0 10px 10px",
                                                            }}>
                                                            <Typography
                                                                component={"h2"}
                                                                fontSize={"18px"}
                                                                color="#000"
                                                                fontWeight={700}>
                                                                Interested in these topics for an upcoming event?
                                                            </Typography>

                                                            <Box marginTop={"1rem"}>
                                                                {/* <Button
                                                        variant="contained"
                                                        color="secondary"
                                                        sx={{
                                                            background: "#444CE7",
                                                            borderColor: "#2D31A6",

                                                            marginRight: "0.5rem",
                                                            maxHeight: 40,

                                                            "&:hover": {
                                                                background: "#444CE7",
                                                            },
                                                        }}>
                                                        Request Speakers
                                                    </Button>
                                                    <Button
                                                        variant="outlined"
                                                        sx={{
                                                            borderColor: "#444CE7",
                                                            color: "#444CE7",
                                                            maxHeight: 40,

                                                            "&:hover": {
                                                                borderColor: "#151dbb",
                                                            },
                                                        }}>
                                                        Request More Info
                                                    </Button> */}
                                                                <Button
                                                                    variant="contained"
                                                                    color="secondary"
                                                                    onClick={() => {
                                                                        navigateToSearch();
                                                                    }}
                                                                    sx={{
                                                                        background: "#444CE7",
                                                                        borderColor: "#2D31A6",

                                                                        marginRight: "0.5rem",
                                                                        maxHeight: 40,

                                                                        "&:hover": {
                                                                            background: "#444CE7",
                                                                        },
                                                                    }}>
                                                                    Search Speakers
                                                                </Button>
                                                            </Box>
                                                        </Box>
                                                    )}
                                                </Box>
                                            )}
                                        </Box>
                                    ))}
                                </>
                            )}
                        </>
                    </Box>
                )}
            </Box>
            {data?.length > 0 && (
                <Modal
                    open={openSpeakerScreen}
                    title="Speaker details"
                    onClose={() => {
                        setOpenSpeakerScreen(false);
                        setSpeakerSearchSelectedTeb("");
                    }}
                    hideActions
                    maxWidth="lg"
                    removeTabIndex
                    sx={{ padding: "0px" }}
                    contentSx={{ overflowY: "hidden" }}
                    PaperProps={{
                        sx: {
                            width: "100%", // added main container width
                        },
                    }}>
                    <Box
                        sx={{
                            height: "calc(100vh - 130px)",
                            // width: {
                            //     xs: "300px",
                            //     md: "590px",
                            //     lg: "auto",
                            // },
                        }}>
                        <Speaker
                            shared={false}
                            actionButtons={false}
                            userDetails={userDetails}
                            opportunityId={""}
                            opportunityName={""}
                            speakerId={selectedSpeaker.Id}
                            recordId={selectedSpeaker.Id}
                            speakerRecord={{
                                speakerName: selectedSpeaker.name,
                                speakerId: selectedSpeaker.Id,
                                speakerImageURL: selectedSpeaker?.img,
                                gender: selectedSpeaker.gender || "",
                            }}
                            removeActions={true}
                            hideFeesTab={false}
                            isBureau={false}
                            feeDetails={"Contact WSB"}
                            displayComments={false}
                            fromSpeakerSearch={true}
                            displayNotes={false}
                            speakerSearchRecord={selectedSpeaker}
                            speakerSearchSelectedTeb={speakerSearchSelectedTeb}
                            applyContainerWidth={true}></Speaker>
                    </Box>
                </Modal>
            )}
        </Paper>
    );
}

export default TopicsFeed;
